module.exports = __webpack_public_path__ + "static/media/twbeltscale.e1910c67.png";